
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yardim",
      function () {
        return require("private-next-pages/yardim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yardim"])
      });
    }
  